import React from "react";
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import AboutMember from "../elements/about/AboutMember"
import AboutBadge from "../elements/about/AboutBadge";


const MemberPortfolio = () => {
    return (
        <>
            <SEO title="IEEE ISSATSo Member Profile || IEEE ISSATSo M profile || IEEE Member Profile IEEE ISSAT Sousse" />
            <Layout>
            {/*Start Slider Area */}
                <div className="slider-perosonal-portfolio height-personalized bg_image" data-black-overlay="1" style={
                                                                                                                        {
                                                                                                                            backgroundImage: `url(${process.env.PUBLIC_URL}/images/about/about.jpg)`,
                                                                                                                            width: `100%`,
                                                                                                                            objectFit: `fill`,
                                                                                                                        }
                                                                                                                    }>
                    <div className="container">
                        <div className="row row--30 align-items-center">
                            <div className="col-12">
                                <div className="inner text-center">
                                    <h2 className="title"><span className="theme-gradient">Gold Member</span></h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                <separator />
                <AboutMember />
                {/* Start Brand Area  */}
                
            {/*End Slider Area */}
                
            {/*Start Brand Area */}
                <AboutBadge />
            {/*End Brand Area */}
            
            </Layout>
        </>
    )
}
export default MemberPortfolio